import { render } from "./CourseCreditGeneralContent.vue?vue&type=template&id=33ff5910&scoped=true"
import script from "./CourseCreditGeneralContent.vue?vue&type=script&lang=js"
export * from "./CourseCreditGeneralContent.vue?vue&type=script&lang=js"

import "./CourseCreditGeneralContent.vue?vue&type=style&index=0&id=33ff5910&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ff5910"]])

export default __exports__